import React, { forwardRef, useImperativeHandle, useEffect, useState } from "react";
import { Endpoints } from "../constants/env/middletier";
import { Dropdown } from 'primereact/dropdown';


const GroupsDropdown = forwardRef(function GroupsDropdown(
  { onGetGroup },
  ref
) {
// function GroupsDropdown({ onGetGroup }) {
  const [groups, setGroups] = useState([]);
  const [groupsList, setGroupsList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupSubs, setSelectedGroupSubs] = useState(null);
  const [loading, setLoading] = useState(true);
    const [selectedSubs, setSelectedSubs] = useState(null);

    useImperativeHandle(ref, () => ({
        async reset() {
            try {
                const res = await fetch(Endpoints["getsubgroupfordropdown"]);
                const data = await res.json();
                setGroups(data);
                console.log("Data Groups");
                console.log(data);
            } catch (err) {
                console.error("Failed to load groups", err);
            } finally {
                setLoading(false);
            }
        }
    }));

  // Fetch all groups on mount
  useEffect(() => {
    async function fetchGroups() {
      try {
        const res = await fetch(Endpoints["getsubgroupfordropdown"]);
        const data = await res.json();
        setGroups(data);
        console.log("Data Groups");
        console.log(data);
      } catch (err) {
        console.error("Failed to load groups", err);
      } finally {
        setLoading(false);
      }
    }
    fetchGroups();
  }, []);

  const handleGroupChange = (e) => {
    const groupName = e.target.value;
    const group = groups.find((g) => g.groupName === groupName);
    setSelectedGroup(e.value);
    onGetGroup(e.value);
//    setSelectedGroupSubs(group.substitutes);
  };

    const setGroupName = (e) => {
        setSelectedSubs(e.value)
        onGetPhoneNumbers(e.value);
    }




  if (loading) return <div>Loading data...</div>;

  return (
    <>
        <div className="card flex justify-content-center">
            <Dropdown
                value={selectedGroup}
                onChange={handleGroupChange}
                options={groups}
                optionLabel="groupName"
                placeholder="Select Group" />
        </div>
    </>
  );
});

export default GroupsDropdown;
